export default __webpack_public_path__ + "static/media/venado_tuerto.4d8443ae.jpg";